import Component from '../core/Component'
import PositionObserver from '../meta/PositionObserver'

class LogoStripe extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            stripeFirst: null,
            stripeSecond: null,
        }

        this.state = {
            active: false,
        }

        this.diff = 0
    }

    prepare() {
        this.observer = new PositionObserver(this.element, {
            onEnter: this.handleEnter,
            onLeave: this.handleLeave,
            onRender: this.handleRender,
            onBeforeResize: this.handleResize,
        })
    }

    destroy() {
        if (this.observer) {
            this.observer.destroy()
            this.observer = null
        }
        this.ref.stripeFirst.removeAttribute('style')
        this.ref.stripeSecond.removeAttribute('style')
        this.state.active = false
    }

    handleResize = () => {
        this.resize()
    }

    handleEnter = () => {
        this.state.active = true
    }

    handleLeave = () => {
        this.state.active = false
    }

    handleRender = ({ ratio, bodyRatio }) => {
        if (!this.state.active) {
            return
        }

        this.render(ratio)
    }

    resize() {
        const box = this.element.getBoundingClientRect()
        const stripeFirst = this.ref.stripeFirst.offsetWidth
        const stripeSecond = this.ref.stripeSecond.offsetWidth
        this.diff = stripeFirst - box.width
        this.diff = stripeSecond - box.width
    }

    render(progress) {
        this.ref.stripeFirst.style.transform = `translateX(${
            -this.diff * ((progress + 1) / 2) + this.diff / 9
        }px)`
        this.ref.stripeSecond.style.transform = `translateX(${
            -this.diff * ((progress + 1) / 4) + this.diff / 8
        }px)`
    }
}

export default LogoStripe
